import {
  BetterDealProduct,
  BetterDealProductDetails,
  BetterDealProductDetailsElecRates,
  BetterDealProductDetailsGasRates,
} from '@1bill-app/services/better-deal/better-deal.type';
import { ChangeDetectionStrategy, Component, Input, OnInit } from '@angular/core';
import { PopoverController } from '@ionic/angular';
import { PopoverSimpleComponent } from '../popover-simple/popover-simple.component';
// TODO ADD TO CONSTANTS...
const CNC_PHONE_NUMBER = '1300 685 001';

@Component({
  selector: 'app-popover-better-deal-product',
  templateUrl: './popover-better-deal-product.component.html',
  styleUrls: ['./popover-better-deal-product.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class PopoverBetterDealProductComponent implements OnInit {
  @Input() productId: number;
  @Input() billPeriod: any;
  @Input() productDetails: BetterDealProductDetails;
  @Input() location: string;
  @Input() state: string;
  @Input() demand: boolean;
  exempt: boolean;
  //hasElectricBill: boolean = true;
  showMarketOffer: boolean = false;
  marketOffer: string;
  marketOfferInfo: string;
  peakRates: string;
  showSolar: boolean;
  solarText: string = '';
  winterSummerRates: {
    winter: string;
    summer: string;
  }[] = [];
  unit: string;
  elecRates: BetterDealProductDetailsElecRates;
  gasRates: BetterDealProductDetailsGasRates;
  isDemandTariff: boolean;
  constructor(private popoverController: PopoverController) {}
  ngOnInit() {
    this.elecRates = this.productDetails?.elecRates[0]?.rates[0];
    this.gasRates = this.productDetails?.gasRates[0]?.rates[0];

    this.unit = this.productDetails?.fuelType == 'Gas' ? ' c/c/MJ ' : ' c/kWh ';
    this.exempt = this.elecRates?.marketComparison?.referenceBillType === 'EXEMPT';
    this.showMarketOffer =
      !this.exempt ||
      (this.exempt &&
        this.productDetails.fuelType == 'Electricity' &&
        !this.productDetails?.isConnection);
    this.isDemandTariff = this.demand;
    if (this.productDetails?.fuelType == 'Electricity') {
      if (this.elecRates?.marketComparison?.referenceBillComparisonPercentage != null) {
        let val = this.elecRates.marketComparison.referenceBillComparisonPercentage;
        this.marketOffer = `${Math.abs(val)}%`;
        this.marketOfferInfo = this.getVDOstring(val);
      }
      this.peakRates = this.getPeakRate();
    }

    if (this.productDetails?.fuelType == 'Gas') {
      this.getGasWinterSummerRates();
    }
    if (
      (this.productDetails?.fuelType == 'Electricity' ||
        this.productDetails?.fuelType == 'Dual') &&
      ((this.elecRates?.solarType == 'Standard' && this.elecRates?.solarRate > 0) ||
        (this.elecRates?.solarType == 'Premium' && this.elecRates?.premiumSolarRate > 0) ||
        this.elecRates?.solarType != 'Unavailable')
    ) {
      this.showSolar = true;

      if (this.elecRates?.solarSteps && this.elecRates?.solarSteps == 2) {
        if (
          this.productDetails.retailerName == 'Red Energy' ||
          this.productDetails.retailerName == 'Lumo Energy' ||
          this.productDetails.retailerName == 'Origin'
        ) {
          this.solarText = ` for the first ${this.elecRates?.solarThreshold} kWh remaining at ${this.elecRates?.solarRate2} c/kWh (Incl. GST where applicable)`;
        } else {
          this.solarText = ` for the first ${this.elecRates?.solarThreshold} kWh remaining at ${this.elecRates?.solarRate2} c/kWh (Excl. GST unless applicable)`;
        }
      } else {
        this.solarText = '';
      }
    }
  }

  dismissPopup() {
    this.popoverController.dismiss();
  }

  selectPlan(id: number) {
    this.popoverController.dismiss({ productIdFromPopover: id });
  }

  public getVDOstring(x: number) {
    const strOffer = this.state == 'VIC' ? 'VDO' : 'DMO';

    if (x < 0) return 'Below ' + strOffer;
    else if (x == 0) return 'Same as ' + strOffer;
    else return 'Above ' + strOffer;
  }

  private getPeakRate(): string {
    var peakStr = '';
    var unit = ' c/kWh ';

    for (let i = 1; i <= 6; i++) {
      if (i == 1 && this.elecRates?.['peak' + i + 'Threshold'] == 'Any usage') {
        peakStr += this.elecRates?.['peak' + i + 'InclGst'].toString() + unit;
      } else {
        peakStr +=
          '\n' +
          this.elecRates?.['peak' + i + 'InclGst'].toString() +
          unit +
          ' ( ' +
          this.elecRates?.['peak' + i + 'Threshold'] +
          ' )';
      }

      if (this.elecRates?.['peak' + i + 'Threshold'] == 'Any usage') break;
    }
    //DEV TEST PEAKS
    //peakStr += '\n 123c/kWh (aykut)';
    return peakStr;
  }

  private getGasWinterSummerRates() {
    var unit = ' c/c/MJ ';

    for (let i = 1; i <= 6; i++) {
      var winter =
        this.gasRates?.['peak' + i + 'InclGst'].toString() +
        unit +
        ' ( ' +
        this.gasRates?.['limit' + i] +
        ' )';
      var summer =
        this.gasRates?.['offPeak' + i + 'InclGst'].toString() +
        unit +
        this.gasRates?.['limit' + i];

      if (winter && summer) {
        this.winterSummerRates.push({
          winter,
          summer,
        });
      }

      if (
        this.gasRates?.['limit' + i] == 'All Usage' ||
        this.gasRates?.['limit' + i] == 'Balance'
      )
        break;
    }
  }

  async presentDocInfoPopover(val: string) {
    var title: string;
    var description: string[];

    // TODO ADD TO CONSTANTS...
    if (val == 'VIC') {
      title = 'Victorian Energy Fact Sheets';
      description = [
        'Victorian Energy Fact Sheets include a comparison table to allow customers to easily compare average annual costs based on postcode.',
        'The rates for your address are dependent on your distribution area and the meter type. The distributors for your location are shown in the &quot;Usage&quot; panel and the Victorian Energy Fact Sheets are for all meter types that may apply to you. The second page of a current electricity bill for that property will show the meter/tariff type.',
        'Most customers are on a single rate tariff. Where the tariff type states &quot;CL&quot; this means Controlled Load. Controlled load is electricity supplied to specific appliances, such as electric hot water systems or slab or underfloor heating, which are often separately metered.',
      ];
    } else {
      title = 'Basic Plan Information Documents';
      description = [
        'Basic Plan information documents are hosted by the Australian Energy Regulator&apos;s Energy Made Easy website. Based on your postcode, a BPID for electricity is available.',
        'Most customers are on a single rate tariff. Where the tariff type states &quot;CL&quot; this means Controlled Load. Controlled load is electricity supplied to specific appliances, such as electric hot water systems or slab or underfloor heating, which are often separately metered.',
        'The rates for your address are dependent on your distribution area and the meter type. The distributors for your location are shown in the &quot;Usage&quot; panel and the Basic Plan Information Documents listed below are for all meter types that may apply to you.',
        `The second page of a current electricity bill for that property will show the meter/tariff type, or, you can call us on ${CNC_PHONE_NUMBER} if you&apos;re unsure.`,
      ];
    }

    const popover = await this.popoverController.create({
      component: PopoverSimpleComponent,
      cssClass: 'onebill-popover-simple',
      mode: 'ios',
      componentProps: {
        popoverTitle: title,
        descriptionArray: description,
        buttonText: 'Close',
        hasBackButton: false,
      },
    });
    await popover.present();
  }

  async presentReferencePricingPopover() {
    //let tariffType = this.products$.subscribe((res) => res[0].electricityRates?.tariffType);
    let title = 'Reference Pricing';
    let description = [
      `The reference price displayed is for a ${
        this.productDetails.elecRates[0]?.rates[0]?.tariffType ?? 'Single Rate'
      } tariff. The Reference Price is a benchmark comparison point that allows consumers to compare the relative price of different offers.`,
      'The energy regulators have established Reference Prices for each electricity distribution zone. Retailers must compare their offers to the reference price. The Reference Price Comparison does not factor in any solar rebates.',
    ];

    const popover = await this.popoverController.create({
      component: PopoverSimpleComponent,
      cssClass: 'onebill-medium-popover',
      mode: 'ios',
      componentProps: {
        popoverTitle: title, // TODO ADD TO CONSTANTS...
        descriptionArray: description,
        buttonText: 'Close',
        hasBackButton: false,
      },
    });
    await popover.present();
  }
}
